module.exports = __webpack_public_path__ + "public/dd7360604912cf0bb7703702efa619c7.svg";